export enum AreaCalculationType {
  Manufactured,
  Raw,
}

export interface MaterialOptions {
  nameMatcher: RegExp | string;
  areaType?: AreaCalculationType;
  jointPointMaxLength?: number;
}

/*
  Materials matching any of these regexp will use the rawMaterialArea calculations
  - wood
  - any laminate products
  */
export const MATERIAL_OPTIONS: MaterialOptions[] = [
  {
    nameMatcher: /^wood$/i,
    areaType: AreaCalculationType.Raw,
    jointPointMaxLength: 97,
  },
  {
    nameMatcher: /^laminate/i,
    areaType: AreaCalculationType.Raw,
    jointPointMaxLength: 97,
  },
];
